<div [ngClass]="{ processing: status === JobStatus.Processing }" class="card">
  <span class="material-symbols-rounded draft">drag_indicator</span>
  <span class="material-symbols-rounded draft">draft</span>
  <div class="file-info">
    <p class="file-name">{{ fileName }}</p>
    <p class="file-size">{{ fileSize.toFixed(2) }}KB</p>
  </div>
  <p
    [ngClass]="(isProcessing$ | async) ? 'visible' : 'invisible'"
    class="status"
  >
    {{ "processingFileCard.jobStatus." + status.toString() | translate }}
  </p>
  <button (click)="deleteUploadedFile()" class="delete-file-button">
    <span class="material-symbols-rounded cancel-button">delete</span>
  </button>
</div>
